// src/actions/types.js

// Auth Actions
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const ACCEPT_POLICY_SUCCESS = 'ACCEPT_POLICY_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';

// Notification Actions
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const ADD_NOTIFICATION_SUCCESS = 'ADD_NOTIFICATION_SUCCESS';
export const MARK_NOTIFICATION_AS_READ_SUCCESS = 'MARK_NOTIFICATION_AS_READ_SUCCESS';
export const FOLLOW_CATEGORY_SUCCESS = 'FOLLOW_CATEGORY_SUCCESS';
export const UNFOLLOW_CATEGORY_SUCCESS = 'UNFOLLOW_CATEGORY_SUCCESS';
export const FETCH_FOLLOWED_CATEGORIES_SUCCESS = 'FETCH_FOLLOWED_CATEGORIES_SUCCESS';
// Post Actions
export const FETCH_POSTS_SUCCESS = 'FETCH_POSTS_SUCCESS';
export const ADD_POST_SUCCESS = 'ADD_POST_SUCCESS';
export const FETCH_USER_POSTS_SUCCESS = 'FETCH_USER_POSTS_SUCCESS';
export const FETCH_USER_POSTS_REQUEST = 'FETCH_USER_POSTS_REQUEST'; // Added
export const FETCH_USER_POSTS_FAILURE = 'FETCH_USER_POSTS_FAILURE'; // Added
export const FETCH_CRITICAL_POST_SUCCESS = 'FETCH_CRITICAL_POST_SUCCESS';
export const FETCH_POSTS_FAILURE = 'FETCH_POSTS_FAILURE'; // Added
export const UPDATE_POST_SUCCESS = 'UPDATE_POST_SUCCESS';
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS';
export const SEARCH_POSTS_SUCCESS = 'SEARCH_POSTS_SUCCESS';
export const FETCH_COMPLETED_POSTS_SUCCESS = 'FETCH_COMPLETED_POSTS_SUCCESS';
export const MARK_POST_COMPLETED_SUCCESS = 'MARK_POST_COMPLETED_SUCCESS';
export const FETCH_COMPLETED_POSTS_FAILURE = 'FETCH_COMPLETED_POSTS_FAILURE';
export const FETCH_POST_SUCCESS = 'FETCH_POST_SUCCESS';
export const FETCH_POST_FAILURE = 'FETCH_POST_FAILURE';
export const SEARCH_POSTS_FAILURE = 'SEARCH_POSTS_FAILURE';
export const SEARCH_POSTS_CLEAR = 'SEARCH_POSTS_CLEAR';
export const CLEAR_POST = 'CLEAR_POST';
export const PARSE_SSR_DATA = 'PARSE_SSR_DATA'; // Added for SSR handling
// Certificate Actions
export const GET_CERTIFICATES = 'GET_CERTIFICATES';
export const CERTIFICATES_ERROR = 'CERTIFICATES_ERROR';
